import { ICoordinate } from "../location";

export interface IGroupSummary {
    id: number;
    code: string;
    color: string;
    ownerId: number;
    coordinates: ICoordinate[];
}